export default (state = {
    innerHtml : ``
     }, action) => {

    switch (action.type) {

        case 'EDIT_EDITOR_DATA':
            return action.payload;

        default:

            return state;

    }

};

